import { http } from "./http.js";

export interface PlatformField {
  key: string;
  label: string;
  type: "text" | "password" | "url";
  description?: string;
  scope: "shop_id" | "app_secret" | "extra";
}

export interface PlatformManifest {
  platform: string;
  label: string;
  webhook_supported: boolean;
  poll_only: boolean;
  required_fields: PlatformField[];
  setup_hints: string[];
}

export async function getCatalog(): Promise<{ platforms: PlatformManifest[]; all_platforms: string[] }> {
  const res = await http.get<{ platforms: PlatformManifest[]; all_platforms: string[] }>(
    "/platforms/catalog",
  );
  return res.data;
}
